var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "v-container",
        { staticClass: "bgw" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _vm.$store.getters.enableStempel
            ? _c(
                "div",
                { staticClass: "mb-6" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df",
                      attrs: { color: "primary", rounded: "", medium: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$ebus.$emit("goto", {
                            name: "Stempelkarte",
                          })
                        },
                      },
                    },
                    [
                      _vm._v("Zur Stempelkarte "),
                      _c("v-icon", { attrs: { medium: "" } }, [
                        _vm._v("mdi-arrow-right"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", [
            _c("h3", { staticClass: "mb-5" }, [_vm._v("Dein Account")]),
          ]),
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "registerForm bigger-input",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Vor- und Nachname *"),
                  ]),
                  _c("v-text-field", {
                    staticClass: "roundInput",
                    attrs: {
                      rules: _vm.nameRules,
                      "hide-no-details": "",
                      illed: "",
                      outlined: "",
                      required: "",
                    },
                    on: { focus: _vm.hideToolbar, blur: _vm.unhideToolbar },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("E-Mail* (Bestelleingangsbestätigung)"),
                  ]),
                  _c("v-text-field", {
                    staticClass: "roundInput",
                    attrs: {
                      type: "email",
                      rules: _vm.emailRules,
                      "hide-no-details": "",
                      illed: "",
                      outlined: "",
                      required: "",
                    },
                    on: { focus: _vm.hideToolbar, blur: _vm.unhideToolbar },
                    model: {
                      value: _vm.formData.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Mobilnummer")]),
                  _c("v-text-field", {
                    ref: "phone",
                    staticClass: "roundInput",
                    attrs: { illed: "", outlined: "", required: "" },
                    model: {
                      value: _vm.formData.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "phone", $$v)
                      },
                      expression: "formData.phone",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "spacer-25" }),
              _vm.displayErrors.length > 0 && _vm.initialTry
                ? _c("div", {
                    staticClass: "error--text mt-2 mr-4",
                    domProps: { innerHTML: _vm._s(_vm.displayErrors) },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-wrap align-center justify-sm-start",
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df mr-5 mt-2 mb-10",
                      attrs: { rounded: "" },
                      on: { click: _vm.doSubmit },
                    },
                    [_vm._v("Übernehmen ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "spacer-25" }),
          _c("div", [_c("h3", [_vm._v("Optionen")])]),
          _c(
            "div",
            { staticStyle: { "max-width": "320px" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mt-4 btn-mini maxw",
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit("goto", { name: "resetPassword" })
                    },
                  },
                },
                [_vm._v(" Passwort vergessen ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mt-4 btn-mini maxw",
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.logout("Logout")
                    },
                  },
                },
                [_vm._v("Abmelden")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mt-4 btn-mini maxw",
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit("goto", { name: "Registrierung" })
                    },
                  },
                },
                [_vm._v(" Neuer Account erstellen ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mt-4 btn-mini maxw",
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.mail(
                        "Account löschen für " + _vm.$store.user.email
                      )
                    },
                  },
                },
                [_vm._v("Account löschen ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-25" }),
          _c("sms-dialog", {
            attrs: { dialog: _vm.smsDialog },
            on: {
              close: function ($event) {
                _vm.smsDialog = false
              },
              cancleDialog: _vm.cancleDialog,
              verifySmsCode: _vm.verifySms,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }